/**
 * On a phone the sections bar stays on every section (Chats, Search, Settings, Administration) and on a page that isn't
 * found; only a conversation covers it, as it covers the list.
 */
export function coversTabBar(pathname: string): boolean {
  return pathname.startsWith('/c/')
}
